<template>
<div container--fluid>
    <v-layout>
        <TeamModule></TeamModule>
    </v-layout>
</div>
</template>

<script>
import TeamModule from '@modules/team/index.vue';

export default {
    name: 'team',
    components: {
        TeamModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
